module.exports = __webpack_public_path__ + "img/varietywa.0243500.png";